import {
	Box,
	Button,
	Card,
	CardContent,
	Chip,
	Divider,
	IconButton,
	Link,
	Menu,
	MenuItem,
	Tooltip,
	Typography,
} from '@mui/material';
import { FC, SyntheticEvent, useRef, useState } from 'react';
import { DateTime } from 'luxon';
import { CountryWithFlag } from 'ui/CountryWithFlag';
import {
	ERRORS_STATUS,
	ErrorsStatus,
	representationSchemeType,
} from 'components/ErrorsCorrections/ErrorsTable/constants';
import { useParams } from 'react-router';
import { errorsTableStructure } from 'components/ErrorsCorrections/ErrorsTable/errors-table-structure';
import { TTableStructure } from 'components/ErrorsCorrections/ErrorsTable/types';
import { UserAvatarMenu } from 'ui/UserAvatarMenu';
import { useDispatch, useSelector } from 'react-redux';
import {
	getErrorCorrection,
	getErrorCorrectionLoader,
	getErrorTypes,
} from 'redux/reducers/errorCorrections/selectors';
import {
	updateResponsibleUserRequest,
	updateStatusRequest,
} from 'redux/reducers/errorCorrections/reducer';
import { getUserInfo, getUsersList } from 'redux/reducers/user/selectors';
import { history } from 'routes/history';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { StatusMenu } from 'ui/StatusMenu';
import { PlatformLogo } from 'ui/PlatformLogo';
import { COLORS } from 'services/constants/colors';
import { EasTableValue } from '../../../../ui/EasTable/EasTableRow/EasTableValue';
import { ETableStructureType } from '../../../../ui/EasTable/types';
import { OpenInNew } from '@mui/icons-material';

// import { errors, errorsIsLoading } from '../../ErrorsTable/errors-data';
// import { error } from '../../ErrorsTable/error-data';

export const ErrorDescription: FC = () => {
	const params = useParams<{ errorId?: string }>();
	const { errorId } = params;
	const dispatch = useDispatch();
	const tableStructure = errorsTableStructure() as TTableStructure[];
	const user = useSelector(getUserInfo);
	const usersList = useSelector(getUsersList);
	const typeOfErrors = useSelector(getErrorTypes);
	// const item = errors.rows.find((i) => i.id === +(errorId ?? 0));
	const item = useSelector(getErrorCorrection);
	const errorCorrectionIsLoading = useSelector(getErrorCorrectionLoader);
	const refStatusFilter = useRef<HTMLButtonElement>(null);
	const [openStatusMenu, setOpenStatusMenu] = useState(false);
	const handleClickStatusMenu = () => {
		setOpenStatusMenu(true);
	};
	const handleCloseStatusMenu = () => {
		setOpenStatusMenu(false);
	};

	// const refUserFilter = useRef<HTMLButtonElement>(null);
	// const [openUserMenu, setOpenUserMenu] = useState(false);
	// const handleClickUserMenu = () => {
	// 	setOpenUserMenu(true);
	// };
	// const handleCloseUserMenu = () => {
	// 	setOpenUserMenu(false);
	// };

	const handleUserSelect = (index: number) => {
		console.log('ErrorDescription handleUserSelect', index);
		if (!usersList) return;
		dispatch(
			updateResponsibleUserRequest({
				errorId: +(errorId ?? 0),
				responsibleUserId: usersList[index].id,
			}),
		);
	};

	const handleSetStatus = (status: ErrorsStatus) => {
		dispatch(updateStatusRequest({ errorId: +(errorId ?? 0), text: String(status) }));
		setOpenStatusMenu(false);
		if (
			status === ErrorsStatus.FIXED &&
			(!item?.responsibleUser?.id ||
				item?.responsibleUser?.id === '00000000-0000-0000-0000-000000000001') &&
			user?.id
		)
			dispatch(
				updateResponsibleUserRequest({
					errorId: +(errorId ?? 0),
					responsibleUserId: user?.id,
				}),
			);
	};

	const handleReplayHistory = () => {
		history.back();
	};

	return (
		<Card>
			<CardContent>
				{errorCorrectionIsLoading && <div>Loading...</div>}
				{!errorCorrectionIsLoading && !!item && (
					<Box
						sx={{
							display: 'flex',
							flexDirection: 'column',
							gap: '10px',
							alignItems: 'flex-start',
						}}
					>
						<Box
							sx={{
								display: 'flex',
								justifyContent: 'space-between',
								alignItems: 'center',
								gap: '24px',
								width: '100%',
							}}
						>
							<Box>
								<IconButton
									onClick={handleReplayHistory}
									color="primary"
									sx={{
										mr: '10px',
									}}
								>
									<KeyboardBackspaceIcon />
								</IconButton>
								<Chip
									label={
										typeOfErrors?.find((i) => i.id === item?.typeOfError)?.name ?? 'Unknown Error'
									}
									size="small"
									// variant="outlined"
									color="error"
									sx={{
										p: '5px',
										fontSize: '1rem',
										height: '34px',
										bgcolor: 'error.light',
										// color: '#00000090',
										fontWeight: '550',
									}}
								/>
							</Box>

							<Box
								sx={{
									display: 'flex',
									gap: '8px',
									alignItems: 'center',
									cursor: 'pointer',
									position: 'relative',
								}}
							>
								<UserAvatarMenu
									user={item?.responsibleUser ?? null}
									users={usersList ?? []}
									size="sm"
									onClick={handleUserSelect}
								/>
								{/* <Menu
										anchorEl={refUserFilter.current}
										open={openUserMenu}
										onClose={handleCloseUserMenu}
										MenuListProps={{
											'aria-labelledby': 'basic-button',
										}}
										sx={{
											'& .MuiMenu-paper': {
												borderRadius: '12px',
											},
										}}
									>
										{tableStructure
											?.find((i) => i.selector === 'responsibleUser')
											?.filter?.map?.((responsibleUser, index) => {
												if (!item) return null;
												return (
													<MenuItem
														key={responsibleUser[0]}
														// onClick={() => handleSelectFilter(index)}
														color="primary"
														sx={{ color: 'primary.main', fontWeight: 'bold', p: '4px 5px' }}
													>
														<UserAvatar user={responsibleUser[1] ?? ''} size="sm" onClick={() => null} />
													</MenuItem>
												);
											}) ?? null}
									</Menu> */}

								{/* <Box
									sx={{
										p: 0,
										m: 0,
										position: 'relative',
									}}
								>
									<Button
										ref={refStatusFilter}
										size="small"
										sx={{
											p: '15px',
											m: 0,
											fontSize: '1rem',
											height: '34px',
											bgcolor:
												item?.status === ErrorsStatus.FIXED
													? 'success.light'
													: item?.status === ErrorsStatus.NEW
													? 'warning.light'
													: item?.status === ErrorsStatus.CONTACTING_CLIENT
													? 'primary.light'
													: item?.status === ErrorsStatus.WORKING_ON_IT
													? 'info.light'
													: '#c5c5c5',
											color: '#00000090',
											cursor: 'pointer',
											fontWeight: '550',
											textTransform: 'none',
											borderRadius: '20px!important',
											'&:hover': {
												bgcolor:
													item?.status === ErrorsStatus.FIXED
														? 'success.main'
														: item?.status === ErrorsStatus.NEW
														? 'warning.main'
														: item?.status === ErrorsStatus.CONTACTING_CLIENT
														? 'primary.main'
														: item?.status === ErrorsStatus.WORKING_ON_IT
														? 'info.main'
														: '#aaa',
												color: '#00000090',
											},
										}}
										onClick={handleClickStatusMenu}
									>
										{item?.status?.replace('_', ' ') ?? 'Unknown Status'}
									</Button>
									<Menu
										anchorEl={refStatusFilter.current}
										open={openStatusMenu}
										onClose={handleCloseStatusMenu}
										MenuListProps={{
											'aria-labelledby': 'basic-button',
										}}
										sx={{
											'& .MuiMenu-paper': {
												borderRadius: '12px',
											},
										}}
									>
										{tableStructure
											?.find((i) => i.selector === 'status')
											?.filter?.map?.((status, index) => {
												if (!item) return null;
												return (
													<MenuItem
														key={status[0]}
														// onClick={() => handleSelectFilter(index)}
														color="primary"
														sx={{ color: 'primary.main', fontWeight: 'bold' }}
													>
														<Button
															size="small"
															sx={{
																p: '15px',
																m: 0,
																fontSize: '1rem',
																height: '24px',
																bgcolor:
																	status[1] === ERRORS_STATUS.FIXED
																		? 'success.light'
																		: status[1] === ERRORS_STATUS.NEW
																		? 'warning.light'
																		: status[1] === ERRORS_STATUS.CONTACTING_CLIENT
																		? 'primary.light'
																		: 'info.light',
																color: '#00000090',
																cursor: 'pointer',
																fontWeight: '550',
																textTransform: 'none',
																borderRadius: '20px!important',
																'&:hover': {
																	bgcolor:
																		status[1] === ERRORS_STATUS.FIXED
																			? 'success.main'
																			: status[1] === ERRORS_STATUS.NEW
																			? 'warning.main'
																			: status[1] === ERRORS_STATUS.CONTACTING_CLIENT
																			? 'primary.main'
																			: 'info.main',
																	color: '#000000',
																},
															}}
															onClick={() => handleSetStatus(status[0])}
														>
															{status[1]}
														</Button>
													</MenuItem>
												);
											}) ?? null}
									</Menu>
								</Box> */}
								<StatusMenu status={item?.status} onClick={handleSetStatus} size="sm" />
							</Box>
						</Box>
						<Divider flexItem />
						<Box
							sx={{
								display: 'flex',
								flexDirection: 'column',
								gap: '10px',
								alignItems: 'flex-start',
								justifyContent: 'flex-start',
							}}
						>
							<PlatformLogo platform={item?.emAdditionalData?.platform ?? ''} />
							<EasTableValue
								type={ETableStructureType.EM}
								value={{ id: item?.emAdditionalData?.emId, name: item?.emName }}
								size="xl"
								color="primary"
							/>
							{item?.site && (
								<Link
									href={`https://${String(item?.site ?? '#')}`}
									target="_blank"
									rel="noreferrer"
									underline="hover"
									color="primary"
									sx={{
										fontWeight: '550',
										fontSize: '1.2rem',
									}}
								>
									{item?.site ?? ''}
								</Link>
							)}
							{item?.emAdditionalData && (
								<>
									<Box>
										<Typography component="span" variant="body2" sx={{ color: COLORS.font_status }}>
											Created at:&nbsp;
										</Typography>
										<Typography
											component="span"
											// variant="body2"
											color="primary"
											sx={{
												fontWeight: '550',
											}}
										>
											{DateTime.fromISO(item?.emAdditionalData?.createdAt ?? '').toFormat(
												'yyyy-MM-dd, HH:mm',
											)}
										</Typography>
									</Box>

									<Box
										sx={{
											display: 'flex',
											gap: '4px',
										}}
									>
										{item.emAdditionalData?.availableSchemes?.map((scheme) => (
											<Chip
												key={scheme}
												label={
													representationSchemeType?.[
														scheme as keyof typeof representationSchemeType
													] ??
													scheme ??
													'Unknown'
												}
												size="small"
												sx={{
													p: '0 5px',
													fontSize: '.9rem',
													height: '26px',
													fontWeight: '550',
													bgcolor: representationSchemeType?.[
														scheme as keyof typeof representationSchemeType
													]
														? 'primary.light'
														: COLORS.BORDER,
													color: COLORS.font_status,
												}}
											/>
										))}
									</Box>
									{!!item.emAdditionalData?.activeScripts?.length && (
										<Box
											sx={{
												display: 'flex',
												flexDirection: 'column',
												gap: '2px',
											}}
										>
											<Typography
												component="span"
												variant="body2"
												sx={{ color: COLORS.font_status }}
											>
												Active Scripts:&nbsp;
											</Typography>
											{item.emAdditionalData?.activeScripts?.map((script) => (
												<Typography
													key={script}
													sx={{
														p: '0 5px',
														fontSize: '.9rem',
														height: '26px',
														fontWeight: '550',
														color: 'primary.main',
													}}
												>
													{script}
												</Typography>
											))}
										</Box>
									)}
									{!!item.emAdditionalData?.skippedValidations?.length && (
										<Box
											sx={{
												display: 'flex',
												flexDirection: 'column',
												gap: '2px',
											}}
										>
											<Typography
												component="span"
												variant="body2"
												sx={{ color: COLORS.font_status }}
											>
												Skipped Validations:&nbsp;
											</Typography>
											{item.emAdditionalData?.skippedValidations?.map((script) => (
												<Typography
													key={script}
													sx={{
														p: '0 5px',
														fontSize: '.9rem',
														height: '26px',
														fontWeight: '550',
														color: 'primary.main',
													}}
												>
													{script}
												</Typography>
											))}
										</Box>
									)}
								</>
							)}
						</Box>
						<Divider flexItem sx={{ mt: '10px' }} />

						<Box
							sx={{
								display: 'flex',
								// justifyContent: 'space-between',
								alignItems: 'center',
								gap: '32px',
								width: '100%',
							}}
						>
							<Box sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
								<Typography component="span" variant="body2" sx={{ color: COLORS.font_status }}>
									External Order ID:&nbsp;
								</Typography>
								{item?.externalOrderId?.includes('@') ? (
									<Tooltip title="View in Order Management with filtering by email">
										<Box
											sx={{
												display: 'flex',
												flexDirection: 'row',
												alignItems: 'center',
												gap: '2px',
											}}
										>
											<OpenInNew
												sx={{
													fontSize: '0.7rem',
													color: COLORS.PRIMARY,
												}}
											/>
											<Link
												href={`/order-management?delivery_email=${item?.externalOrderId}&searchEmId=${item?.emAdditionalData?.emId ?? ''}`}
												target="_blank"
												rel="noreferrer"
												underline="hover"
												color={COLORS.PRIMARY}
												sx={{
													fontWeight: '550',
												}}
											>
												{item?.externalOrderId}
											</Link>
										</Box>
									</Tooltip>
								) : (
									<Typography
										component="span"
										variant="body2"
										sx={{ color: COLORS.PRIMARY, fontWeight: '550' }}
									>
										{item?.externalOrderId}
									</Typography>
								)}
							</Box>
							<Box sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
								<Typography component="span" variant="body2" sx={{ color: COLORS.font_status }}>
									EAS Order ID:
								</Typography>
								<EasTableValue
									type={ETableStructureType.ORDER_ID}
									value={item?.easOrderId}
									size="l"
									color={COLORS.PRIMARY}
								/>
							</Box>
						</Box>
						<Box
							sx={{
								display: 'flex',
								// justifyContent: 'space-between',
								alignItems: 'center',
								gap: '32px',
								width: '100%',
							}}
						>
							<Typography
								component="span"
								// variant="body2"
								color="primary"
								sx={{
									fontWeight: '550',
								}}
							>
								{DateTime.fromISO(item?.orderDate).toFormat('yyyy-MM-dd, HH:mm')}
							</Typography>

							<CountryWithFlag countryCode={item?.deliveryCountry} size="s" color="primary" bold />
							<Chip
								label={
									representationSchemeType?.[
										item.schemes as keyof typeof representationSchemeType
									] ??
									item?.schemes ??
									'Unknown'
								}
								size="small"
								sx={{
									p: '0 5px',
									fontSize: '.9rem',
									height: '26px',
									fontWeight: '550',
									// border: '1px solid #ffffff',
									bgcolor: representationSchemeType?.[
										item.schemes as keyof typeof representationSchemeType
									]
										? 'primary.light'
										: COLORS.BORDER,
									color: COLORS.font_status,
									// color: 'primary.main',
								}}
							/>
						</Box>
						<Divider flexItem />

						<Typography component="p" variant="body2">
							{item.errorDescription}
						</Typography>
					</Box>
				)}
			</CardContent>
		</Card>
	);
};
